"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const decode_uri_component_1 = __importDefault(require("decode-uri-component"));
const path_to_regexp_1 = require("path-to-regexp");
const query_string_1 = __importDefault(require("query-string"));
const url_parse_1 = __importDefault(require("url-parse"));
const constants_1 = require("./constants");
const utils_1 = require("./utils");
class TSURL {
    constructor(schema, options = constants_1.DEFAULT_OPTIONS) {
        this.options = Object.assign(Object.assign({}, constants_1.DEFAULT_OPTIONS), options);
        this.schema = schema;
    }
    construct(urlParams, queryParams) {
        var _a;
        const path = utils_1.constructPath(urlParams, this.schema, this.options);
        if (!((_a = this.options.queryParams) === null || _a === void 0 ? void 0 : _a.length)) {
            return path;
        }
        const queryParamsString = utils_1.constructQuery(queryParams, this.options.queryParams, this.options);
        if (!queryParamsString) {
            return path;
        }
        return `${path}?${queryParamsString}`;
    }
    deconstruct(url) {
        const template = this.getURLTemplate();
        const parsed = url_parse_1.default(this.options.decode ? decode_uri_component_1.default(url) : url, false);
        const urlMatch = path_to_regexp_1.match(template)(parsed.pathname);
        if (!urlMatch) {
            throw new Error(`Provided url "${url}" was invalid`);
        }
        const queryParams = query_string_1.default.parseUrl(url, {
            decode: this.options.decode,
            arrayFormat: this.options.queryArrayFormat,
            arrayFormatSeparator: this.options.queryArrayFormatSeparator,
        }).query;
        return {
            urlParams: utils_1.serializeURLParams(urlMatch.params, this.schema),
            queryParams: utils_1.serializeQueryParams(queryParams, this.options.queryParams || []),
        };
    }
    getURLTemplate() {
        const urlParams = {};
        this.schema.forEach(part => {
            if (typeof part === 'object') {
                if (utils_1.isRequired(part)) {
                    urlParams[part.name] = `:${part.name}`;
                }
                else {
                    urlParams[part.name] = `:${part.name}?`;
                }
            }
        });
        return utils_1.constructPath(urlParams, this.schema, this.options);
    }
}
exports.TSURL = TSURL;
//# sourceMappingURL=tsurl.js.map